import axios from "axios";
const { authHeader } = require("./headerConfig");

const API_ENDPOINT = process.env.REACT_APP_ENDPOINT + "/api/x-admin";

const linkAccount = async () => {
  const response = await axios.get(`${API_ENDPOINT}/telegram-link-activation`, {
    withCredentials: true,
    headers: {
      ...authHeader(),
      Accept: "application/json",
    },
  });
  console.log(response.data);
  
  return response.data;
};
const unlinkAccount = async () => {
  const response = await axios.get(`${API_ENDPOINT}/unlink-telegram-account`, {
    withCredentials: true,
    headers: {
      ...authHeader(),
      Accept: "application/json",
    },
  });
  return response.data;
};

const telegramServices = {
  linkAccount,
  unlinkAccount,
};
export default telegramServices;
